/* eslint-disable import/no-unresolved */
import React from "react";
import UserOrderDetail from "components/pages/user/orders/UserOrderDetail";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopOrderDetail = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <UserOrderDetail {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopOrderDetail);
